import { HttpContextToken } from "@angular/common/http";

export const AUTHORIZATION_TYPE: HttpContextToken<'hmac' | 'jwt' | 'none'> = new HttpContextToken(() => 'none');
export const DEMO: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
export const ERROR_TYPE_VIEW: HttpContextToken<'page' | 'popup' | 'none'> = new HttpContextToken<"page" | "popup" | "none">(() =>'popup');
